import {modelActionsCreator} from "~/actions/model_actions";
import {getModel, getParentId} from "~/stateGetter";


type AddRelationshipThunkArg = {
    value: {
        isNewItem: boolean;
        values: Record<string, {value: unknown}>
    };
    modelId: string;
}


export default function addRelationshipThunk (arg: AddRelationshipThunkArg)  {
    return (dispatch, getState) => {
        const state = getState();
        let {value: record, modelId } = arg;
        
        if (!record.isNewItem) {
            const parentModelId = getParentId(state, modelId);
            if (parentModelId ) dispatch(modelActionsCreator(parentModelId).invalidateRelationAutocompleteByModelId());
            return;
        }
        
        if (!record?.values?.id) return;

        dispatch(modelActionsCreator(modelId).setRelationshipValue(record.values.id.value));
        
    }
}